import { ApiProperty } from "@nestjs/swagger";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

export class ServiceUploadDto {
    @ApiProperty()
    maintenanceName: string | null;
    @ApiProperty()
    serveId: string | null;
    @ApiProperty()
    fileName: string | null;
    @ApiProperty()
    filePath: string | null;

}